import React, {useContext} from 'react'
import {CustomerContext} from '../../CustomerContext'
import BaseReportPane from '@/app/modules/p2c/dashboard/components/panes/EarningsReportPane'

const EarningsReportPane = () => {
  const { customer } = useContext(CustomerContext)

  if (!customer) {
    return (<></>)
  }

  return (
    <BaseReportPane customer={customer} />
  )
}

export default EarningsReportPane
